import util from '@bmp-vue/core/api/util'

const controller = 'LimiteAprovacaoConta'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByContaId: function (id) {
    return util.Axios.Get(controller + '/GetByConta', id)
  },
})
